// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__2KfVW","chart":"Card_chart__zRLCJ"};